import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { Chart as ChartJS, LineElement, PointElement, LinearScale, CategoryScale, Title, Tooltip, Legend } from 'chart.js';
import { Line } from 'react-chartjs-2';
import { useTitle } from './TitleContext'; // Import the provider
// import PolBias from '../images/Political Bias Tracker.png';
import PosSent from '../images/Positivity Sentiment Tracker.png';
import MedMent from '../images/Media Mentions Frequency.png';
import '../App.css';

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Title,
  Tooltip,
  Legend
);

function HomePage() {
  const navigate = useNavigate()
  const { setTitle } = useTitle();
  useEffect(() => {
    setTitle("Gradient Dashboard"); // Set the title for the home page
  }, [setTitle]);
  const goPolBias = () => {
    navigate('/political_bias');  // Navigate to the home page
  };
  const goPosSen = () => {
    navigate('/positivity_sentiment');  // Navigate to the home page
  };
  const goMedMen = () => {
    navigate('/media_mentions');  // Navigate to the home page
  };
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: []  // Ensure datasets is at least an empty array
  });

  useEffect(() => {
    fetch('https://gradient-backend.onrender.com/api/data')
      .then(response => response.json())
      .then(data => {
        setChartData({
          labels: data.dates,
          datasets: [
            {
              label: 'Social Bias',
              data: data.social.bias,
              borderColor: 'rgb(255, 99, 132)',
              backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
            {
              label: 'News Bias',
              data: data.news.bias,
              borderColor: 'rgb(54, 162, 235)',
              backgroundColor: 'rgba(54, 162, 235, 0.5)',
            }
          ],
        });
      })
      .catch(error => console.error('Error fetching data:', error));
  }, []);
  return (
    <>
      <div className="main-content">
        {/* Add your images and statistics here */}
        <h2>Political Bias Tracker</h2>
        <div className="tracker-container">
        <div className="chart-container">
          <Line data={chartData} />
        </div>
          <div className="tracker-info">
          <p><span className="highlight">7-Day Average:</span><br /> News: -12<br /> Social: -38</p>
            <p><span className="highlight">30-Day Average:</span><br /> News: -8<br /> Social: -24</p>
            <p><span className="highlight">6-Month Average:</span><br /> News: -3<br /> Social: -18</p>
            <button onClick={goPolBias}>Expand</button>
            </div>
        </div>
        {/* <div className="tracker-container">
          <img src={PolBias} alt="Political Bias Tracker" />
          <div className="tracker-info">
            
            <p><span className="highlight">7-Day Average:</span><br /> News: -12<br /> Social: -38</p>
            <p><span className="highlight">30-Day Average:</span><br /> News: -8<br /> Social: -24</p>
            <p><span className="highlight">6-Month Average:</span><br /> News: -3<br /> Social: -18</p>
            <button onClick={goPolBias}>Expand</button>
          </div>
        </div> */}
        <h2>Positivity Sentiment Tracker</h2>
        <div className="tracker-container">
          <img src={PosSent} alt="Positivity Sentiment Tracker" />
        <div className="tracker-info">
            <p><span className="highlight">7-Day Average:</span><br /> News: -18<br /> Social: -46</p>
            <p><span className="highlight">30-Day Average:</span><br /> News: -2<br /> Social: -19</p>
            <p><span className="highlight">6-Month Average:</span><br /> News: 11<br /> Social: 32</p>
            <button onClick={goPosSen}>Expand</button>
          </div>
        </div>
        <h2>Media Mentions Frequency</h2>
        <div className="tracker-container">
          <img src={MedMent} alt="Media Mentions Frequency" />
          <div className="tracker-info">
            <p><span className="highlight">7-Day Average:</span><br /> News: 319<br /> Social: 13,000</p>
            <p><span className="highlight">30-Day Average:</span><br /> News: 190<br /> Social: 8,000</p>
            <p><span className="highlight">6-Month Average:</span><br /> News: 108<br /> Social: 6,000</p>
            <button onClick = {goMedMen}>Expand</button>
          </div>
        </div>
      </div>
    </>
  );
}

export default HomePage;
